import styled from "styled-components";
import { Color, Font, breakpoints, ColorDark} from "@/shared/Constants";

export const WesternAstrologyContainer = styled.div`
  border-bottom: 1px solid ${Color.greySeparator};
  padding-bottom: 30px;
  width: 100%;
  ${breakpoints.darkMode} {
    [data-theme='dark'] & {
    border-bottom:1px solid ${ColorDark.greySeparator};
    }
  }
  ${breakpoints.phone} {
    margin-left: 0;
    margin-bottom: 0;
  }
  .western-astrology-header {
    align-items: center;
    border-bottom: 1px solid ${Color.greySeparator};
    display: flex;
    justify-content: flex-start;
    padding-bottom: 20px;
    padding-top: 20px;
    width: 100%;
    .western-astrology-header-title {
      ${Font.sansRegular};
      color: ${Color.grey};
      font-size: 14px;
      ${breakpoints.darkMode} {
        [data-theme='dark'] & {
        color:${ColorDark.textLight};
        }
      }
    }
  }
  .western-astrology-content {
    align-items: center;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    width: 100%;
    ${breakpoints.phone} {
      border-right: none;
    }
    .western-astrology-sign-since,
    .western-astrology-sign-dash,
    .western-astrology-sign-until {
      ${Font.sansRegular};
      color: ${Color.black000};
      font-size: 16px;
    }
    .western-astrology-sign-dash {
      padding: 0 5px;
    }
  }
`;
